<script>
    import { store } from '../../Store.svelte';
    import { env } from '../../Environment.svelte';
    import { mobilePlans } from '../../data/mobilePlans';
    import {
        CONSTANTS,
        MOVIL_CATEGORIES,
        MULTI_CATEGORIES,
        RESIDENCIAL_CATEGORIES,
        TRIPLEPLAY_CATEGORIES,
        TV_CATEGORIES,
    } from './utils/constant';
    import {
        calculateDiscountCost,
        calculateOriginalCost,
        getIsIncludedStreaming,
        getMovilPlan,
    } from './utils/utils';
    import InternetPlanType from './components/InternetPlanType.svelte';
    import MovilPlanType from './components/MovilPlanType.svelte';
    import PricesPlanType from './components/PricesPlanType.svelte';
    import TvPlanType from './components/TvPlanType.svelte';
    import DescriptionCollapsePlanType from './components/DescriptionCollapsePlanType.svelte';
    import SeparatorPlanType from './components/SeparatorPlanType.svelte';
    import ExtrasIncludedPlanType from './components/ExtrasIncludedPlanType.svelte';

    export let home = false;
    export let checkedCombos = false;
    export let plan, category, selectedMovilTerm, selectedMovilMobileData;

    const {
        CATEGORY_4PLAY,
        CATEGORY_TRIPLEPLAY_MOVIL,
        CATEGORY_MOVIL,
        CATEGORY_TV,
        CATEGORY_IZZI_NEGOCIOS4P,
    } = CONSTANTS;

    const { vel, title, nombreCode, paqId, cost } = plan;

    let movilCost = 0;
    let movilTitle = '';
    let movilExtName = '';
    let selectedPlanMovilId;
    $: includedStreaming = getIsIncludedStreaming(plan, checkedCombos);

    if (selectedMovilTerm && selectedMovilMobileData) {
        selectedPlanMovilId =
            mobilePlans[selectedMovilTerm][selectedMovilMobileData];
        if (getMovilPlan(plan, selectedPlanMovilId)) {
            const { cost, title, extName } = getMovilPlan(
                plan,
                selectedPlanMovilId
            ).plan.extra;

            movilCost = Number(cost);
            movilTitle = title;
            movilExtName = extName;
        }
    }

    const isPlanActive =
        ![60].includes(vel) &&
        !(MOVIL_CATEGORIES.has(category) && plan.vel === 1000);

    $: isFixedTerm =
        title.includes('12 meses') || movilTitle.includes('12 meses');

    const is6MonthsPromo = TRIPLEPLAY_CATEGORIES.has(category);
    const is3MonthsPromo = RESIDENCIAL_CATEGORIES.has(category);
    const isFixedContract = false;

    const hasRecurrentPaymentPromo = MULTI_CATEGORIES.has(category);
    const hasToCalculateFinalCost = MULTI_CATEGORIES.has(category);

    const originalFinalCost = hasToCalculateFinalCost
        ? calculateOriginalCost(plan, movilCost, category, checkedCombos)
        : cost;
    const discountFinalCost =
        hasRecurrentPaymentPromo &&
        calculateDiscountCost(plan, movilCost, category, checkedCombos);

    const includesInternet = MULTI_CATEGORIES.has(category);
    const includesMovil = MOVIL_CATEGORIES.has(category);
    const includesTv = TV_CATEGORIES.has(category);

    const shouldShowPromo = MULTI_CATEGORIES.has(category);
    const shouldShowExtras =
        MULTI_CATEGORIES.has(category) || TV_CATEGORIES.has(category);

    const isVixPremiumIncluded = MULTI_CATEGORIES.has(category);

    const addPlanStore = () => {
        $store.requestedServices.izzimovil = [
            CATEGORY_4PLAY,
            CATEGORY_TRIPLEPLAY_MOVIL,
            CATEGORY_IZZI_NEGOCIOS4P,
        ].includes(category)
            ? [getMovilPlan(plan, selectedPlanMovilId)]
            : [];
        $store.requestedServices.isSpMovil = category === CATEGORY_MOVIL;
        if (isVixPremiumIncluded) $store.requestedServices.isVix = true;

        if (
            $store.requestedAddress.postalCode != null &&
            $store.requestedAddress.postalCode.length > 0 &&
            !home
        ) {
            if (category === CATEGORY_TV) {
                $store.requestedServices.isCombo = false;
                $store.requestedServices.isVix =
                    // nombreCode === 'izzitv_ottm' ||
                    // nombreCode === 'izzitv_basico' ||
                    nombreCode === 'izzitv_light' ||
                    nombreCode === 'izzitv_lightm';
            }

            plan['productFamily'] = category;
            $store.requestedServices.autoinstalacion = plan.autoinstalacion;
            $store.requestedServices.channelExtras = [];
            $store.requestedServices.productId = paqId;
            $store.requestedServices.product = plan;
            $store.requestedServices.tvExtensionsExtras = [];
            $store.requestedServices.phoneExtras = [];
            $store.requestedServices.phoneExtensionsExtras = [];
            $store.purchaseStatus = env.cleanstore.purchaseStatus;
            $store.requestedServices.isNetflix =
                includedStreaming.IS_NETFLIX_ADD_INCLUDED ||
                includedStreaming.IS_NETFLIX_ESTANDAR_INCLUDED;
            $store.requestedServices.isHBO = includedStreaming.IS_MAX_INCLUDED;
            $store.requestedServices.isHBOAdds =
                includedStreaming.IS_MAX_ADD_INCLUDED &&
                ![80, 100].includes(vel) &&
                ![CATEGORY_TV].includes(category);
            window.scrollTo(0, 0);

            let token = encodeStorageData(
                $store.requestedAddress,
                $store.requestedServices
            );

            window.top.parent.location = `${env[env.stage].urlweb}/receiver/purchase/${token}`;
        } else {
            $store.requestedServices.productObject.productFamily = category;
            $store.requestedServices.productObject.productId = paqId;
            $store.requestedServices.productObject.productSpeed = vel;
            MicroModal.show('modal-cobertura');
        }
    };

    function encodeStorageData(requestedAddress, requestedServices) {
        let storageData = {};
        storageData['requestedAddress'] = requestedAddress;
        storageData['productId'] = requestedServices.productId;
        storageData['izziMovil'] = requestedServices.izzimovil;
        storageData['productFamily'] = requestedServices.product.productFamily;

        requestedServices.product = {};
        requestedServices.izzimovil = {};
        storageData['requestedServices'] = requestedServices;

        return Object.keys(storageData).length > 0
            ? btoa(encodeURIComponent(JSON.stringify(storageData)))
            : '';
    }
</script>

{#if isPlanActive}
    <div class="plan-card">
        <div>
            <div class="plan-card__header">
                {#if includesInternet}
                    <InternetPlanType {vel} {category} />
                {/if}
                {#if includesMovil}
                    <MovilPlanType movilTitle={movilTitle || title} />
                {/if}
                {#if includesTv}
                    <TvPlanType {title} />
                {/if}
                <PricesPlanType
                    originalPrice={originalFinalCost}
                    discountPrice={discountFinalCost}
                />
            </div>
            {#if shouldShowPromo}
                <p class="plan-card__promo">
                    {#if is6MonthsPromo}
                        Precio con promoción por 6 meses.<br />
                    {/if}
                    {#if is3MonthsPromo}
                        Precio con promoción por 3 meses.<br />
                    {/if}
                    {#if hasRecurrentPaymentPromo}
                        Incluye $50 de descuento por domiciliar.
                        {#if isFixedContract}
                            Contrato a 12 meses
                        {/if}
                    {/if}
                </p>
            {/if}
        </div>
        <button
            class="plan-card__cta pure__button pure__button--base pure__button--expand"
            on:click={() => addPlanStore()}
        >
            contratar
        </button>
        <SeparatorPlanType {category} />
        <div class="plan-card__footer">
            {#if shouldShowExtras}
                <ExtrasIncludedPlanType {plan} {category} {checkedCombos} />
            {/if}
            <div class="plan-card__contract">
                {#if includesInternet || includesTv}
                    <p>CONTRATO A 12 MESES</p>
                {/if}
                {#if includesMovil}
                    {#if !isFixedTerm}
                        <p><span>izzi móvil</span> SIN PLAZO</p>
                    {:else if isFixedTerm && CATEGORY_MOVIL === category}
                        <p><span>izzi móvil</span> CON PLAZO</p>
                    {/if}
                {/if}
            </div>
            <DescriptionCollapsePlanType
                {plan}
                {category}
                {checkedCombos}
                {movilExtName}
            />
        </div>
    </div>
{/if}
